import { ValueContainer } from "./ValueContainer";
import { ValuesContainer } from "./Values.styled";

export interface ValueItemProps {
  icon: any;
  title: string;
  body: string;
}

export interface ValuesContent {
  values: ValueItemProps[];
}

export interface ValuesProps extends ValuesContent {
  className?: string;
}

export const Values = ({ values, className }: ValuesProps) => {
  return (
    <ValuesContainer className={className}>
      {values.map((value, index) => (
        <ValueContainer key={index} icon={value.icon} title={value.title}>
          {value.body}
        </ValueContainer>
      ))}
    </ValuesContainer>
  );
};
